/* Slash command extension (Phase 5e §2.4).
 *
 * Wires @tiptap/suggestion to trigger on `/` at the start of an empty
 * paragraph. Filters the COMMANDS list by query and dispatches the
 * picked command's `command({ editor, range })` runner.
 */
import { Extension } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';
import { COMMANDS, renderCommandList } from './command-list.js';

export const SlashCommand = Extension.create({
  name: 'slashCommand',
  addOptions() {
    return {
      suggestion: {
        char: '/',
        startOfLine: true,
        allowSpaces: false,
        items: ({ query }) => {
          const q = (query || '').toLowerCase();
          if (!q) return COMMANDS;
          return COMMANDS.filter(c =>
            c.title.toLowerCase().includes(q) ||
            (c.aliases || []).some(a => a.includes(q))
          );
        },
        command: ({ editor, range, props }) => props.command({ editor, range }),
        render: renderCommandList,
      },
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});
